const holidays = {
  // MM-DD
  fixed: [
    '12-31', // Ano novo
    '01-01', // Ano novo
    '01-25', // Niver SP
    '04-21', // Tiradentes
    '05-01', // Dia do Trabalho
    '07-09', // Revolução constitucionalista de 1932
    '09-07', // Independecia do Brasil
    '10-12', // Nossa Sr. Aparecida
    '11-02', // Finados
    '11-15', // Proclamação da República
    '11-20', // Consciencia Negra
    '12-24', // Natal
    '12-25', // Natal
  ],
  // YYYY-MM-DD
  yearly: [
    '2026-02-16', // Carnaval
    '2026-02-17', // Carnaval
    '2026-04-03', // Paixão de Cristo
    '2026-06-04', // Corpus Christi
  ],
};

module.exports = (date) => {
  if (holidays.fixed.includes(date.format('MM-DD'))) return true;
  if (holidays.yearly.includes(date.format('YYYY-MM-DD'))) return true;
  return false;
};
